import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  id?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  action,
  id,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-5 border-b border-background-200 pb-6 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow ? (
          <p className="label-caps text-[11px] text-primary-600">{eyebrow}</p>
        ) : null}
        <h2
          id={id}
          className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl"
        >
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}